var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem20B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 33.101,
    cy: 381.54,
    r: 26.239,
    gradientTransform: "matrix(1.4267 0 0 1.4266 616.01 -443.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 33.118,
    cy: 381.52,
    r: 18.038,
    gradientTransform: "matrix(1.4267 0 0 1.4266 380.25 -443.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 33.101,
    cy: 381.54,
    r: 13.166,
    gradientTransform: "matrix(1.4267 0 0 1.4266 138.43 -443.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m688.58 126.32c13.77-16.806 13.77-33.612 0-50.31-7.373-7.0478-15.83-10.517-25.372-10.517-9.4332 0-17.89 3.4697-25.155 10.517-13.987 16.698-13.987 33.504 0 50.31 7.2646 6.9393 15.614 10.409 25.155 10.409 9.65 0 17.999-3.4697 25.372-10.409z",
    fill: "url(#f)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m735.85 95.197-1.8433-2.6022-222.71 160.04 1.8433 2.6022 222.71-160.04z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.16 118.73c9.7584-11.819 9.7584-23.529 0-35.239-5.2045-4.8792-11.06-7.2646-17.674-7.2646-6.7225 0-12.469 2.3854-17.565 7.2646-9.8669 11.71-9.8669 23.42 0 35.239 4.9876 4.8792 10.843 7.373 17.565 7.373 6.5056 0 12.469-2.4938 17.674-7.373z",
    fill: "url(#e)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m482.02 95.197-1.9517-2.6022-222.71 160.04 1.8433 2.6022 222.82-160.04z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.27 88.583c-3.6865-3.4697-7.9152-5.3129-12.686-5.3129-4.6624 0-8.7826 1.7348-12.469 5.3129-7.0478 8.3489-7.0478 16.698 0 25.155 3.5781 3.4697 7.8068 5.2045 12.469 5.2045 4.7708 0 9.1079-1.7348 12.686-5.2045 6.9393-8.4573 6.9393-16.806 0-25.155z",
    fill: "url(#d)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.76 95.197-1.8433-2.6022-222.82 160.04 1.9517 2.6022 222.71-160.04z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0845 0 0 1.0843 736.83 66.049)",
    x: -27.22772,
    y: -6.39898,
    fontFamily: "'ArialMT'",
    fontSize: "16.6px",
    stroke: "null"
  }, "10kg"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0845 0 0 1.0843 503.94 66.049)",
    x: -27.22772,
    y: -6.39898,
    fontFamily: "'ArialMT'",
    fontSize: "16.6px",
    stroke: "null"
  }, "5kg"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0845 0 0 1.0843 242.2 66.049)",
    x: -27.22772,
    y: -6.39898,
    fontFamily: "'ArialMT'",
    fontSize: "16.6px",
    stroke: "null"
  }, "1kg"), /*#__PURE__*/React.createElement("path", {
    d: "m124.34 235.72c-3.2031-3.2031-6.94-4.8046-11.478-4.8046s-8.4081 1.6015-11.611 4.8046-4.8046 7.0734-4.8046 11.611 1.6015 8.4081 4.8046 11.611 7.0734 4.8046 11.611 4.8046 8.2746-1.6015 11.478-4.8046 4.8046-7.0734 4.8046-11.611-1.6015-8.4081-4.8046-11.611z",
    fill: "#369",
    fillOpacity: 0.502,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.3321 0 0 1.3346 116.34 228.31)",
    x: -6.50744,
    y: 19.11767,
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px",
    stroke: "null"
  }, "1"), /*#__PURE__*/React.createElement("path", {
    d: "m404.61 235.72c-3.2031-3.2031-6.94-4.8046-11.478-4.8046s-8.4081 1.6015-11.611 4.8046-4.8046 7.0734-4.8046 11.611 1.6015 8.4081 4.8046 11.611 7.0734 4.8046 11.611 4.8046 8.2746-1.6015 11.478-4.8046 4.8046-7.0734 4.8046-11.611-1.6015-8.4081-4.8046-11.611z",
    fill: "#369",
    fillOpacity: 0.502,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.3321 0 0 1.3346 465.55 228.31)",
    x: -58.30624,
    y: 19.11767,
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px",
    stroke: "null"
  }, "2"), /*#__PURE__*/React.createElement("path", {
    d: "m668.02 235.72c-3.2031-3.2031-6.94-4.8046-11.478-4.8046s-8.4081 1.6015-11.611 4.8046-4.8046 7.0734-4.8046 11.611 1.6015 8.4081 4.8046 11.611 7.0734 4.8046 11.611 4.8046 8.2746-1.6015 11.478-4.8046 4.8046-7.0734 4.8046-11.611-1.6015-8.4081-4.8046-11.611z",
    fill: "#369",
    fillOpacity: 0.502,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.3321 0 0 1.3346 764.03 228.31)",
    x: -84.58099,
    y: 19.11767,
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px",
    stroke: "null"
  }, "3"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem20B);
export default __webpack_public_path__ + "static/media/item20b.3dcae9fb5384a889a9db87c7206b9ee1.svg";
export { ForwardRef as ReactComponent };